export class Pause {
  constructor(
    public hash: string,
    public startTime: number,
    public endTime: number,
    public cause: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/pause.ts